import { FontWeight, LiliCheckboxNew, LiliTextArea, Text } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import type { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

interface FundingSourceOptionProps {
  option: {
    value: string;
    getLabel: () => string;
    field: EddEmbeddedFields;
    placeholder: string;
  };
  selectedOptions: string[];
  onOptionChange: (option: string) => void;
  id: string;
}

export const FundingSourceOption = ({
  option,
  selectedOptions,
  onOptionChange,
  id,
}: FundingSourceOptionProps) => {
  const isSelected = selectedOptions.includes(option.value);

  return (
    <div className='flex flex-col gap-4'>
      <LiliCheckboxNew
        id={id}
        checked={isSelected}
        onCheckedChange={() => onOptionChange(option.value)}
        label={<Text.H10 fontWeight={FontWeight.MEDIUM}>{option.getLabel()}</Text.H10>}
        labelAlign='center'
      />

      {isSelected && (
        <div>
          <ControllerWrapper name={option.field} shouldUnregister>
            {({ onChange, value, error, onBlur }) => (
              <LiliTextArea
                id={`${id}-text-area`}
                value={value}
                onValueChange={onChange}
                errorMsg={error?.message || ''}
                externalErrorMessage={error?.message || ''}
                maxLength={100}
                minHeight='min-h-[88px]'
                placeholder={option.placeholder}
                onBlur={onBlur}
              />
            )}
          </ControllerWrapper>
        </div>
      )}
    </div>
  );
};
